import React from "react";
import { IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { useTranslation } from "react-i18next";

const EditButton = ({ onClick }) => {
  const { t } = useTranslation();
  return (
    <IconButton
      onClick={() => {
        onClick();
      }}
      variant="contained"
      color="primary"
      sx={{
        padding: "8px 16px 8px 12px",
        height: "40px",
        display: "inline-flex",
        flexShrink: 0,
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        gap: "8px",
        cursor: "pointer",
        fontSize: "14px",
        fontWeight: "normal",
        borderRadius: "6px",
        backgroundColor: "var(--main-color)",
        color: "#FFFF",
        border: "none",
        textTransform: "none",
        transition: "all 0.2s ease-in-out",
        "&:hover": {
          backgroundColor: "var(--secondary-color)",
          color: "#ffffff",
          boxShadow: "0 2px 4px #91A3FF",
        },
      }}
    >
      {t("dataModelDetail.edit")}
      <EditIcon />
    </IconButton>
  );
};

export default EditButton;
